module.exports = __webpack_public_path__ + "img/hu.966f4933.svg";